import { Instance } from 'mobx-state-tree'

import { WordpressDailyInspirationModelBase } from './WordpressDailyInspirationModel.base'

/* The TypeScript type of an instance of WordpressDailyInspirationModel */
export interface WordpressDailyInspirationModelType extends Instance<typeof WordpressDailyInspirationModel.Type> {}

/* A graphql query fragment builders for WordpressDailyInspirationModel */
export {
  selectFromWordpressDailyInspiration,
  wordpressDailyInspirationModelPrimitives,
  WordpressDailyInspirationModelSelector
} from './WordpressDailyInspirationModel.base'

/**
 * WordpressDailyInspirationModel
 */
export const WordpressDailyInspirationModel = WordpressDailyInspirationModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
